import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DailyLeadStatsList from '../components/DailyLeadStatsList';

const DailyLeadStatsPage = () => {
    return (
        <Routes>
            <Route path="/" element={<DailyLeadStatsList />} />
        </Routes>
    );
};

export default DailyLeadStatsPage;